/**
 * Public constants for the toolbar IDs. If not listed here, a toolbar is considered internal and not accessible to the user.
 */
export const CORE_TOOLBAR_IDS = {
    DETAILS: "details",
} as const;

export type CoreToolbarId = (typeof CORE_TOOLBAR_IDS)[keyof typeof CORE_TOOLBAR_IDS];
